export function applyStyles(el, styles) {
    Object.entries(styles).forEach(([name, value]) => {
        el.style[name] = value;
    });
}

export function getSlideIden(slideId){
    return String(slideId).padStart(2, "0");
}

export function getSlide(container, id) {
    return container.querySelector(`[data-slider-item-id="${id}"]`);
}

export function getSlidesTrack(container) {
    return container.querySelector(".slick-track");
}

export function animateTrack(track, scrollToElement, config) {
    const offset = config.vertical ? scrollToElement.offsetTop : scrollToElement.offsetLeft;
    if (config.vertical) {
        track.style.transform = `translate3d(0, -${offset}px, 0)`;
    } else {
        track.style.transform = `translate3d(-${offset}px, 0, 0)`;
    }
}
